// Module
var code = "<h3>Enlightenment Questions - Question From Vinod</h3> <p>Dear Tathagata,</p> <p>Have you heard of Sathya Sai Baba and what do you think of him ?</p> <p>Vinod Patel</p> ";
// Exports
module.exports = code;